var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6855 1.7413C11.2947 1.39693 10.6871 1.42392 10.33 1.80457L4.47391 8.05624L1.64477 5.26782C1.27131 4.90111 0.664605 4.89553 0.287324 5.25665C-0.0909241 5.61684 -0.0966853 6.20598 0.275802 6.57269L3.81724 10.0629C3.99869 10.2416 4.24443 10.3412 4.5017 10.3412C4.50746 10.3412 4.51419 10.3412 4.51995 10.3421C4.78491 10.3365 5.03453 10.2267 5.21211 10.0368L11.7507 3.05644C12.1069 2.67481 12.0781 2.08661 11.6855 1.7413Z",
    fill: "#ABAFBD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 12,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6855 1.7413C11.2947 1.39693 10.6871 1.42392 10.33 1.80457L4.47391 8.05624L1.64477 5.26782C1.27131 4.90111 0.664605 4.89553 0.287324 5.25665C-0.0909241 5.61684 -0.0966853 6.20598 0.275802 6.57269L3.81724 10.0629C3.99869 10.2416 4.24443 10.3412 4.5017 10.3412C4.50746 10.3412 4.51419 10.3412 4.51995 10.3421C4.78491 10.3365 5.03453 10.2267 5.21211 10.0368L11.7507 3.05644C12.1069 2.67481 12.0781 2.08661 11.6855 1.7413Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1.5,
    width: 14.4,
    height: 14.4,
    fill: "#ABAFBD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "c7f1cb0828bb3b6f0ba124d3d0e2180b.svg";
export { ForwardRef as ReactComponent };